import { Select, ConfigProvider } from "antd";
import React from "react";
import { Colors } from "../../config";
import useColors from "../../hooks/useColors";

const SelectField = ({
  containerStyle,
  className,
  defaultValue,
  value,
  options,
  inputStyle,
  onSelect,
  onSearch,
  onChange,
  placeholder,
  allowClear,
  notFoundContent = true,
  size,
  mode,
  ...props
}) => {
  const { colorPrimary } = useColors()
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            /* here is your component tokens */
            optionSelectedBg: colorPrimary,
            selectorBg: Colors.LightGray,
            optionActiveBg: Colors.LightGray,
            optionSelectedColor: Colors.White,
            paddingSM: 28,
            colorTextPlaceholder: Colors.DarkGray
          },
        },
      }}

    >
      <Select
        allowClear={false}
        className={className}
        defaultValue={defaultValue}
        value={value}
        notFoundContent={notFoundContent}
        options={options}
        style={inputStyle}
        onSelect={onSelect}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        mode={mode}
        {...props}
      />
    </ConfigProvider>
  );
};

export default SelectField;
